.streams-cotainer{flex:1 1 546px;box-sizing:border-box;max-width:544px;min-width:544px}
/*# sourceMappingURL=streams-content.component-YQKCJGHD.css.map */
